import { gql, useQuery } from '@apollo/client';
import { DateRangeValue } from '../../../shared/types';

const gqlQueryFilter = gql`
    query overviewTripsTaxiState {
        CITRIN_MGT_overviewTripsTaxiState @client
    }
`;
const typeName = 'CITRIN_MGT_overviewTripsTaxiState';

export type OverviewState = {
    quickStatusFilter?: string;
    selectedDateRange?: DateRangeValue;
    search?: string;
    page?: number;
    pageSize?: number;
};

const initialState: OverviewState = {
    quickStatusFilter: 'All',
    selectedDateRange: {
        fromDate: undefined,
        toDate: undefined,
    },
    search: '',
    page: 1,
    pageSize: 10,
};

export const useOverviewLinkState = (): [OverviewState, (newState: OverviewState) => void] => {
    const { data, client } = useQuery(gqlQueryFilter, { fetchPolicy: 'cache-first' });
    const setState = (newState: OverviewState) => {
        client.writeQuery({
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewTripsTaxiState: {
                    value: newState,
                    __typename: typeName,
                },
            },
        });
    };
    return [data?.CITRIN_MGT_overviewTripsTaxiState?.value ?? initialState, setState];
};

export default {
    defaults: [
        {
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewTripsTaxiState: {
                    value: initialState,
                    __typename: 'CITRIN_MGT_overviewTripsTaxiState',
                },
            },
        },
    ],
};
